/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-array-index-key */
import React from 'react'

import { CarouselComponent, CtaButton, Image } from '../../components'
import { Heading, Kicker } from '../../components/Typography'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useTrustMarks } from '../../hooks/useTrustMarks'
import { useTrustLogos } from '../../hooks/useTrustMarksImages'
import { SectionContainer } from '../../layouts'
import {
  btnMargin,
  carouselContainer,
  contentCotnainer,
  ctaContainer,
  extraKicker,
  headerStyling,
  headingContainer,
  logoImage,
  logoItem,
  logosContainer,
  sectionContainer,
} from './TrustSection.module.css'

const NewTrustSection = ({ lang }) => {
  const trustMarks = useTrustMarks()
  const newLogosData = useTrustLogos()
  const newLogos = newLogosData.map((logo) => logo.trustmarkpresets.logo.node)
  const localizedTrustMarks = trustMarks.filter(
    (mark) => mark.language.slug === lang,
  )
  const { trustmarkscontent } = localizedTrustMarks[0]
  const { trustmarkcta, trustmarkheading, trustmarkicker } = trustmarkscontent

  const isDesktop = useMediaQuery('(min-width: 768px)')
  const logosRender =
    newLogos.length > 0 &&
    newLogos.map((logo, index) => {
      return (
        <div key={index} className={logoItem}>
          <Image
            alt={logo.altText || 'Kliniken Image'}
            className={logoImage}
            src={logo.localFile.childImageSharp}
          />
        </div>
      )
    })
  let ctaContent = trustmarkcta
  if (typeof trustmarkcta === 'string') {
    ctaContent = JSON.parse(trustmarkcta)
  }

  const trustContent = isDesktop ? (
    <div className={logosContainer}>{logosRender}</div>
  ) : (
    <div className={carouselContainer}>
      <CarouselComponent children={logosRender} isDesktop={isDesktop} />
    </div>
  )

  return (
    <SectionContainer
      extraClassName={sectionContainer}
      extraContentClassName={contentCotnainer}
    >
      <div className={headingContainer}>
        <div className={headerStyling}>
          {trustmarkicker && (
            <Kicker extraClassName={extraKicker} gold>
              {trustmarkicker}
            </Kicker>
          )}
          {trustmarkheading && <Heading>{trustmarkheading}</Heading>}
        </div>
        {trustContent}
        {trustmarkcta && isDesktop && (
          <div className={ctaContainer}>
            <CtaButton
              type="primary"
              {...ctaContent}
              className={btnMargin}
              title="Gratis Consult"
            />
            <CtaButton
              type="secondary"
              {...ctaContent}
              className={btnMargin}
              title="Call us now"
            />
          </div>
        )}
      </div>
      {trustmarkcta && !isDesktop && (
        <CtaButton type="primary" {...ctaContent} />
      )}
    </SectionContainer>
  )
}

export default NewTrustSection
